import { render, staticRenderFns } from "./TransactionRoomBooking.vue?vue&type=template&id=4898955f&scoped=true"
import script from "./TransactionRoomBooking.vue?vue&type=script&lang=js"
export * from "./TransactionRoomBooking.vue?vue&type=script&lang=js"
import style0 from "./TransactionRoomBooking.vue?vue&type=style&index=0&id=4898955f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4898955f",
  null
  
)

export default component.exports